"use client";

import Button from "@/components/Button/Button.component";
import { BUTTON_SUBTYPE_CLASS } from "@/components/Button/Button.model";
import { Typography } from "@/components/Typography/Typography.component";
import { cn } from "@/lib/utils";
import { COLOR_NAME, COLOR_PICKER } from "@/types/Contentful.model";
import NextImage from "next/image";
import { ImageText5050PropsModel } from "./ImageText5050.model";

const ImageText5050 = ({
  textCollection,
  image,
  cta,
  textColor,
  backgroundColor,
}: ImageText5050PropsModel) => {
  return (
    <div
      className={cn(
        "image-text-5050-component bg-core-red relative grid gap-20 px-2 pt-20 pb-42 md:grid-cols-2 md:gap-0 md:px-4 md:py-6",
        backgroundColor?.value &&
          `bg-${COLOR_PICKER[backgroundColor.name as COLOR_NAME]}`,
      )}
    >
      <div className="relative grid pl-2 md:items-center md:pl-6">
        <div className="grid grid-cols-2">
          {textCollection.slice(0, 2).map((text, index) => (
            <Typography.H6
              key={index}
              className={cn(
                "text-core-black !font-semibold",
                textColor?.value === "#ffffff" && `text-core-white`,
                index === textCollection.length - 1 && "justify-self-end",
              )}
            >
              {text}
            </Typography.H6>
          ))}
        </div>
      </div>
      <div className="relative">
        <div className="absolute top-0 left-0 grid h-full w-full grid-cols-2 items-center px-2 md:px-6">
          {textCollection.slice(2, 4).map((text, index) => (
            <Typography.H6
              key={index}
              className={cn(
                "text-core-black !font-semibold",
                textColor?.value === "#ffffff" && `text-core-white`,
                index === 1 && "justify-self-end",
              )}
            >
              {text}
            </Typography.H6>
          ))}
        </div>
        <div className="w-full">
          <NextImage
            src={image?.url}
            alt={image?.title || ""}
            className="h-full w-full object-cover"
            width={image?.width}
            height={image?.height}
          />
        </div>
      </div>
      {cta && (
        <div className="absolute bottom-20 left-4 md:bottom-[214px] md:left-10">
          <Button
            primary
            type={BUTTON_SUBTYPE_CLASS.PRIMARY_WHITE_OUTLINE}
            content={{ text: cta.text, url: cta.url }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageText5050;
